import { pageViewTypes } from "@constants/tracking";
import { FaqsContainer, dialogTexts } from "@features/faqs";
import useAnalytics from "@hooks/useAnalytics";
import { Box } from "@memorang/ui";
import ModalHeader from "components/ModalHeader";
import { Stack } from "expo-router";
import { useTranslation } from "react-i18next";

const FaqsRoute = () => {
	const config = dialogTexts.faqs;
	const { t } = useTranslation();

	useAnalytics({
		type: pageViewTypes.faq,
	});

	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader backIcon="arrow-left" headerTitle={t(config.title)} />
					),
				}}
			/>
			<Box padding={16} paddingBottom={84}>
				<FaqsContainer />
			</Box>
		</>
	);
};

export default FaqsRoute;
